<template>
    <div class="org_settings">
        <h1 class="mb-2">Agency Settings</h1>
        <div class="row px-2 mb-5">
            <div class="card py-3">
                <div class="card-body">
                    <div id="org_settings_scorecard">
                        <h3>Results Filter for {{ client.name }}</h3>
                        <p>A unique feature of Avid is the ability to see all of your client's progress on a single page page when you first log into the system. To make this as relevant as possible, we allow you to adjust what transactions and donors are counted toward the results shown on this screen.</p>
                        <p>Whatever transactions you filter to below will be used for all team members within your organization.</p>

                        <div class="row">
                            <div class="col position-relative mb-3">
                                <button class="btn btn-secondary btn-icon-only-md d-none d-xl-block position-absolute" @click="toggleExpand"
                                 data-bs-toggle="tooltip" title="Toggle full width" style="right: 6px; top: -8px;">
                                    <img :src="is_expanded ? '/img/icons/avid-icons/minimize-4.svg' : '/img/icons/avid-icons/maximize-4.svg'" class="icon " style="width:14px;" alt="">
                                </button>

                                <div v-if="data_blend.id === null">
                                    <h4 class="d-flex align-items-center">
                                        <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        Loading Filter Options
                                    </h4>
                                </div>
                                <div v-else>
                                    <query-builder 
                                        :client="local_client" 
                                        v-model="local_client.agency_results[0].results_filter"
                                        :static_db_columns="data_blend.source_columns"
                                        :include_trans="true" 
                                        :source="data_blend.data_source" 
                                        :in_card="true" 
                                        :add_blank="true"
                                        :data_source_id="data_blend.id" 
                                        ref="filter"
                                    ></query-builder>
                                </div>
                            </div> 
                            <div class="d-none d-xl-block drill-down mb-3" :class="(is_expanded ? 'col-12' : 'col-4')">
                                <preview-table 
                                    :client="local_client" 
                                    :source="{
                                        data_source: {
                                            data_source: data_blend.data_source,
                                            id: data_blend.id
                                        }
                                    }"
                                    :source_columns="db_columns"
                                    :data_type="null"
                                ></preview-table>
                            </div>
                        </div>

                        <button 
                            type="submit" 
                            class="btn btn-primary mt-5 btn-lg" 
                            @click.prevent="update" 
                            :disabled="form.busy"
                        >
                            <img class="icon" src="/img/icons/avid-icons/save.svg" alt=""> Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import Swal from 'sweetalert2';
    import { useNotifications } from '../../composables/useNotifications';

    export default defineComponent({
        name: 'AgencyClientResults',
        setup() {
            const { showNotification } = useNotifications();
            return {
                showNotification
            };
        },
        props: {
            client: {
                type: Object,
                required: true
            },
            data_blend: {
                type: Object,
                required: true
            },
            agency: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                local_client: {},
                db_columns: [],
                form: {
                    busy: false,
                    error: false
                },
                is_expanded: false,
            };
        },
        beforeMount() {
            this.local_client = this.client;
            this.loadDatabaseColumns();
        },
        methods: {
            loadDatabaseColumns() {
                let data = {
                    client: this.client,
                    include_trans: true,
                    source: this.data_blend.data_source,
                    data_source_id: this.data_blend.id,
                };
                window.axios.post('/api/bigquery/get_db_columns', data)
                .then(response => {
                    this.db_columns = response.data.columns;
                });
            },
            update() {
                var self = this;
                this.form.busy = true;

                let data = {
                    filter: this.local_client.agency_results[0].results_filter
                }

                window.axios.post('/api/agencies/'+this.agency.id+'/clients/'+ this.local_client.url+'/results', data)
                .then(response => {
                    self.form.busy = false;
                    Swal.fire({
                        title: "Filter Successfully Updated",
                        text: "The results will be updated at the next data refresh",
                        icon: "success",
                        confirmButtonText: "OK",
                        customClass: {
                            popup: 'swal-success'
                        },
                        }).then((result) => {
                            //Redirect to the prior page
                            window.history.back();
                        });
                }).catch(error =>{
                    self.form.busy = false;
                    self.form.error = true;
                    setTimeout( function() {self.form.error = false} , 10000);
                    this.showNotification({
                        text: 'Error saving your filter. Please try again.',
                        type: 'error'
                    });

                });
            },
            toggleExpand() {
                this.is_expanded = !this.is_expanded;
            }
        }
    })
</script>
